import { Injectable, Inject, DOCUMENT } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IConnectionAvailabilityService } from '../common/i-connection-availability.service';

// https://github.com/angular/angular/issues/20351
/** @dynamic */
@Injectable({ providedIn: 'root' })
export class ConnectionAvailabilityBrowserService implements IConnectionAvailabilityService {
  private isAvailable = new BehaviorSubject<boolean>(true);
  private _window: any;

  public constructor(@Inject(DOCUMENT) private document: Document) {
    this._window = this.document.defaultView.window;
    this.isAvailable.next(this._window.navigator.onLine);

    this._window.addEventListener('online', () => this.isAvailable.next(true));
    this._window.addEventListener('offline', () => this.isAvailable.next(false));
  }

  public get isConnectionAvailable(): Observable<boolean> {
    return this.isAvailable.asObservable();
  }
}
